<template>
  <div class="header">
    <div class="container-fluid">
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <!-- Breadcrumb Section -->
            <!-- Breadcrumb and Buttons Section in the same row -->
            <div class="row align-items-center">
              <!-- Left side: Breadcrumb -->
              <div class="col d-flex align-items-center">
                <p class="mb-0">Ideation</p>
              </div>
              <!-- Right side: Buttons -->
              <div class="col-auto">
                <b-button
                  v-b-modal.modal-new-ideation
                  variant="primary"
                  @click="idetionsnews()"
                  v-if="
                    [
                      'Super Admin',
                      'General User',
                      'Genta Gendis',
                      'Demand Touchpoint',
                    ].includes(roles)
                  "
                >
                  <span class="fe fe-file-plus"></span> Ideation
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Ideation List" class="p-0">
              <div class="card-body">
                <b-tabs content-class="mt-3" fill>
                  <b-tab
                    title="All Ideation"
                    :active="actives == 'all' ? true : false"
                    @click="filterStatus('all')"
                  ></b-tab>
                  <b-tab
                    title="Draft"
                    :active="actives == 'draft' ? true : false"
                    @click="filterStatus('draft')"
                  ></b-tab>
                  <b-tab
                    title="On Review"
                    :active="actives == 'on_review' ? true : false"
                    @click="filterStatus('on_review')"
                  ></b-tab>
                  <b-tab
                    title="Revision Ideation"
                    :active="actives == 'revision' ? true : false"
                    @click="filterStatus('revision')"
                  ></b-tab>
                  <b-tab
                    title="Revision Verification"
                    @click="filterStatus('revision_verification')"
                  ></b-tab>
                  <b-tab
                    title="Rejected"
                    :active="actives == 'rejected' ? true : false"
                    @click="filterStatus('rejected')"
                  ></b-tab>
                  <b-tab
                    title="Hold"
                    :active="actives == 'hold' ? true : false"
                    @click="filterStatus('hold')"
                  ></b-tab>
                  <b-tab
                    title="Development"
                    :active="actives == 'development' ? true : false"
                    @click="filterStatus('development')"
                  ></b-tab>
                  <b-tab
                    title="DSO"
                    :active="actives == 'dso' ? true : false"
                    @click="filterStatus('dso')"
                  ></b-tab>
                </b-tabs>

                <div
                  class="d-flex flex-column flex-md-row justify-content-between flex-wrap mb-3"
                >
                  <!-- Left: Search -->
                  <div class="d-flex align-items-center mb-2 mb-md-0">
                    <label class="mb-0 mr-2">Search</label>
                    <b-form-input
                      v-model="body.search"
                      class="w-100 w-md-auto"
                      placeholder="Type Here..."
                      @change="getListIdeation()"
                    />
                    <div class="form-check d-flex align-items-center ml-2">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="acknowledgeCheckbox"
                        v-model="isAcknowledge"
                        @change="handleIsAcknowledge"
                      />
                      <label
                        class="form-check-label ml-1"
                        for="acknowledgeCheckbox"
                      >
                        Acknowledge
                      </label>
                    </div>
                  </div>

                  <!-- Right: Page size selector -->
                  <div class="d-flex align-items-center">
                    <label class="mb-0 mr-2">Show</label>
                    <v-select
                      v-model="body.pageSize"
                      @input="getListIdeation"
                      style="min-width: 100px; width: 100%; max-width: 120px"
                      :options="[10, 50, 100]"
                      :clearable="false"
                    />
                  </div>
                </div>

                <!-- Make table responsive -->
                <div class="table-responsive">
                  <vue-good-table
                    mode="remote"
                    :line-numbers="false"
                    :columns="columns"
                    :rows="ideationList.data"
                    :total-rows="ideationList.totalItems"
                    :sort-options="{ enabled: true }"
                    :pagination-options="{
                      enabled: true,
                      perPage: body.pageSize,
                    }"
                    style-class="vgt-table table table-bordered"
                    @on-sort-change="onSortChange"
                    @on-page-change="onPageChange"
                    @on-per-page-change="onPageChange"
                    :isLoading.sync="isLoading"
                  >
                    <div slot="emptystate" class="text-center font-size-14">
                      No data available
                    </div>
                    <template slot="table-row" slot-scope="props">
                      <!-- Table Action -->
                      <span v-if="props.column.field == 'action'">
                        <b-dropdown
                          id="dropdown-dropleft"
                          dropleft
                          variant="primary"
                          class="m-2"
                        >
                          <!-- item view detail -->
                          <b-dropdown-item
                            class="hovering"
                            title="Detail"
                            :to="{
                              name: `ideationDetails`,
                              params: { id: props.row.id },
                            }"
                          >
                            View Detail
                          </b-dropdown-item>

                          <!-- item for edit -->
                          <b-dropdown-item
                            v-if="
                              showEditDelete(
                                props.row.status,
                                props.row.created_by.fullname
                              )
                            "
                            class="hovering"
                            title="Edit"
                            @click="updateDraft(props.row)"
                          >
                            Edit
                          </b-dropdown-item>

                          <!-- item for delete  -->
                          <b-dropdown-item
                            v-if="
                              showEditDelete(
                                props.row.status,
                                props.row.created_by.fullname
                              )
                            "
                            class="hovering"
                            title="Delete"
                            @click="deleteData(props.row.id)"
                          >
                            Delete
                          </b-dropdown-item>

                          <!-- item FU acknowledge by gg and requestor -->
                          <b-dropdown-item
                            v-if="
                              props.row.status ==
                                'Review By Demand Touch Point' &&
                              (['Super Admin', 'Genta Gendis'].includes(
                                roles
                              ) ||
                                props.row.created_by.fullname.includes(
                                  fullnames
                                ))
                            "
                            class="hovering"
                            title="Follow Up Acknowledge"
                            @click="
                              showModalNotification('fu acknowledge', props.row)
                            "
                          >
                            Follow Up
                          </b-dropdown-item>

                          <!-- item Response acknowledge -->
                          <b-dropdown-item
                            v-if="
                              props.row.status ==
                                'Review By Demand Touch Point' &&
                              ['Super Admin', 'Demand Touchpoint'].includes(
                                roles
                              )
                            "
                            class="hovering"
                            title="Response Acknowledge"
                            @click="
                              showModalNotification(
                                'response acknowledge',
                                props.row
                              )
                            "
                          >
                            Response
                          </b-dropdown-item>

                          <!-- item acknowledge demtouch -->
                          <b-dropdown-item
                            v-if="
                              forDemandTouchpoint(props.row.status) &&
                              ['Super Admin', 'Demand Touchpoint'].includes(
                                roles
                              )
                            "
                            class="hovering"
                            title="Acknowledge Demand Touch Point"
                            @click="
                              showModalNotification('acknowledge', props.row)
                            "
                          >
                            Acknowledge
                          </b-dropdown-item>
                        </b-dropdown>
                      </span>
                      <span v-else-if="props.column.field === 'date'">
                        {{ convertDate(props.row.date) }}
                      </span>
                      <span v-else-if="props.column.field === 'name'">
                        <span
                          v-for="(part, index) in splitText(props.row.name, 30)"
                          :key="index"
                        >
                          {{ part }}
                        </span>
                      </span>
                    </template>
                    <template slot="pagination-bottom" slot-scope="props">
                      <div class="d-flex justify-content-end">
                        <div>
                          <b-pagination
                            :value="1"
                            :total-rows="ideationList.totalItems"
                            :per-page="body.pageSize"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="m-3"
                            @input="
                              (value) =>
                                props.pageChanged({ currentPage: value })
                            "
                          >
                          </b-pagination>
                        </div>
                      </div>
                    </template>

                    <!-- Your table-row and pagination-bottom slots stay unchanged -->
                  </vue-good-table>
                </div>
              </div>
            </b-tab>
            <b-tab title="Module List" class="p-0">
              <div class="card-body">
                <b-tabs content-class="mt-3" fill>
                  <b-tab
                    title="All Module"
                    @click="filterModule('all_module')"
                  ></b-tab>
                  <b-tab
                    title="Pra-Golive"
                    @click="filterModule('pragolive_module')"
                  ></b-tab>
                  <b-tab
                    title="Go Live"
                    @click="filterModule('golive_module')"
                  ></b-tab>
                  <b-tab
                    title="Monitoring"
                    @click="filterModule('monitoring_module')"
                  ></b-tab>
                  <b-tab
                    title="DSO"
                    @click="filterModule('dso_module')"
                  ></b-tab>
                </b-tabs>

                <div
                  class="d-flex flex-column flex-md-row justify-content-between flex-wrap mb-3"
                >
                  <!-- Left: Search -->
                  <div class="d-flex align-items-center mb-2 mb-md-0">
                    <label class="mb-0 mr-2">Search</label>
                    <b-form-input
                      v-model="bodyModule.search"
                      class="w-100 w-md-auto"
                      placeholder="Type Here..."
                      @change="getListModule()"
                    />
                  </div>

                  <!-- Right: Page size selector -->
                  <div class="d-flex align-items-center">
                    <label class="mb-0 mr-2">Show</label>
                    <v-select
                      v-model="bodyModule.pageSize"
                      @input="getListModule"
                      style="min-width: 100px; width: 100%; max-width: 120px"
                      :options="[10, 50, 100]"
                      :clearable="false"
                    />
                  </div>
                </div>

                <!-- Make table responsive -->
                <div class="table-responsive">
                  <vue-good-table
                    mode="remote"
                    :line-numbers="false"
                    :columns="columnsModule"
                    :rows="moduleList.data"
                    :total-rows="moduleList.totalItems"
                    :sort-options="{ enabled: true }"
                    :pagination-options="{
                      enabled: true,
                      perPage: bodyModule.pageSize,
                    }"
                    style-class="vgt-table table table-bordered"
                    @on-sort-change="onSortChangeModule"
                    @on-page-change="onPageChangeModule"
                    @on-per-page-change="onPageChangeModule"
                    :isLoading.sync="isLoading"
                  >
                    <div slot="emptystate" class="text-center font-size-14">
                      No data available
                    </div>
                    <template slot="table-row" slot-scope="props">
                      <!-- Table Action -->
                      <span v-if="props.column.field == 'action'">
                        <div class="d-flex justify-content-center flex-wrap">
                          <!-- Detail Button -->
                          <b-button
                            class="no-wrap btn-pill ml-2 text-white"
                            variant="info"
                            size="sm"
                            v-b-tooltip.hover
                            title="Detail"
                            @click="detailModule(props.row.id)"
                          >
                            <span class="fe fe-info"></span>
                          </b-button>

                          <!-- Pra Golive Button -->
                          <b-button
                            v-if="isPragoliveRole(props.row.status)"
                            class="no-wrap btn-pill ml-2 text-white"
                            variant="primary"
                            size="sm"
                            @click="
                              openModalPragolive(
                                'pra_golive',
                                props.row.id,
                                props.row.ideation.ideation_id
                              )
                            "
                          >
                            Pra Golive
                          </b-button>

                          <!-- Go Live Button -->
                          <b-button
                            v-if="isGoLiveRole(props.row.status)"
                            class="no-wrap btn-pill ml-2 text-white"
                            variant="primary"
                            size="sm"
                            @click="
                              openModalGoLive(
                                'golive',
                                props.row.id,
                                props.row.ideation.ideation_id
                              )
                            "
                          >
                            Go Live
                          </b-button>

                          <!-- Monitoring Button -->
                          <b-button
                            v-if="isMonitoringFlow(props.row.status)"
                            class="no-wrap btn-pill ml-2 text-white"
                            variant="primary"
                            size="sm"
                            @click="
                              openModalMonitoring(
                                'monitoring',
                                props.row.id,
                                props.row.ideation.ideation_id
                              )
                            "
                          >
                            Monitoring
                          </b-button>
                        </div>
                      </span>
                      <span v-else-if="props.column.field === 'date'">
                        {{ convertDate(props.row.date) }}
                      </span>
                      <span v-else-if="props.column.field === 'feature'">
                        {{ props.row.feature.join(", ") }}
                        <!-- <ul>
                                                <li v-for="(item, index) in props.row.feature" :key="index">
                                                    {{ item }}
                                                </li>
                                            </ul> -->
                      </span>
                      <span v-else-if="props.column.field === 'name'">
                        <span
                          v-for="(part, index) in splitText(props.row.name, 30)"
                          :key="index"
                        >
                          {{ part }}
                        </span>
                      </span>
                    </template>
                    <template slot="pagination-bottom" slot-scope="props">
                      <div class="d-flex justify-content-end">
                        <div>
                          <b-pagination
                            :value="1"
                            :total-rows="moduleList.totalItems"
                            :per-page="bodyModule.pageSize"
                            first-number
                            last-number
                            align="right"
                            prev-class="prev-item"
                            next-class="next-item"
                            class="m-3"
                            @input="
                              (value) =>
                                props.pageChanged({ currentPage: value })
                            "
                          >
                          </b-pagination>
                        </div>
                      </div>
                    </template>

                    <!-- Your table-row and pagination-bottom slots stay unchanged -->
                  </vue-good-table>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </div>
    <b-modal
      id="modal-new-ideation"
      hide-footer
      size="xl"
      title="New Ideation"
      @hide="confirmClose"
    >
      <b-tabs content-class="mt-3" v-model="tabIndex">
        <b-tab title="Ideation" active>
          <div class="row">
            <div class="col-lg-4">
              <div class="form-group">
                <label>Requestor Name <span class="text-danger">*</span></label>
                <v-select
                  v-model="payloadIdeation.requestor_nik"
                  :options="requestorList"
                  name="Requestor Name"
                  v-validate="'required'"
                  :reduce="(e) => e.nik"
                  label="fullname"
                >
                </v-select>
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Requestor Name')"
                  >{{ errors.first("Requestor Name") }}</span
                >
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label>Genta/Gendis <span class="text-danger">*</span></label>
                <v-select
                  v-model="payloadIdeation.genta_gendis_email"
                  :options="ggList.data"
                  name="Genta/Gendis"
                  v-validate="'required'"
                  :reduce="(e) => e.email"
                  label="name"
                >
                </v-select>
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Genta/Gendis')"
                  >{{ errors.first("Genta/Gendis") }}</span
                >
              </div>
            </div>
            <div class="col-lg-4">
              <div class="form-group">
                <label>Ideation Date<span class="text-danger">*</span></label>
                <!-- <input type="date" class="form-control" v-model="payloadIdeation.date"
                                    name="Ideation Date" v-validate="'required'"> -->
                <datepicker
                  input-class="form-control"
                  format="dd/MM/yyyy"
                  placeholder="dd/mm/yyyy"
                  v-model="payloadIdeation.date"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Ideation Date')"
                  >{{ errors.first("Ideation Date") }}</span
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label
                  >Project Ideation Name
                  <span class="text-danger">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="payloadIdeation.name"
                  name="Project Ideation Name"
                  v-validate="'required||max:200'"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Project Ideation Name')"
                  >{{ errors.first("Project Ideation Name") }}</span
                >
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label
                  >Expected Time Delivery
                  <span class="text-danger">*</span></label
                >
                <v-select
                  v-model="payloadIdeation.time_delivery"
                  :clearable="false"
                  :options="[
                    '1-3 Month',
                    '3-6 Month',
                    '6-9 Month',
                    '9-12 Month',
                  ]"
                ></v-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6">
              <h2 class="mt-3">
                Background <span class="text-danger">*</span>
              </h2>
              <div
                v-for="(item, index) in backgroundList(
                  payloadIdeation.background
                )"
                :key="index"
              >
                <b-form-checkbox
                  :id="`checkbox-${item.label}`"
                  :name="`checkbox-${item.label}`"
                  :value="true"
                  :unchecked-value="false"
                  v-model="item.selected"
                >
                  {{ item.label }}
                </b-form-checkbox>

                <div class="mb-3" v-if="item.selected == true">
                  <label class="mb-0"
                    >Write down the reasons
                    <span class="text-danger">*</span></label
                  >
                  <textarea
                    class="form-control"
                    v-model="item.reason"
                    :name="`Reason ${item.label}`"
                    v-validate="'required'"
                  />
                  <span
                    class="text-sm text-danger"
                    v-show="errors.has(`Reason ${item.label}`)"
                    >{{ errors.first(`Reason ${item.label}`) }}</span
                  >
                </div>
              </div>
              <span v-if="validationBackground" class="text-sm text-danger">
                Please select at least one Background
              </span>
            </div>
            <div class="col-lg-6">
              <h2 class="mt-3">
                Budget Availability <span class="text-danger">*</span>
              </h2>
              <b-form-group v-slot="{ ariaDescribedby }">
                <b-form-radio
                  v-model="payloadIdeation.budget_availability[1].value"
                  :aria-describedby="ariaDescribedby"
                  name="Budget Avaibility"
                  v-validate="'required'"
                  value="Available"
                  >Available</b-form-radio
                >
                <b-form-radio
                  v-model="payloadIdeation.budget_availability[1].value"
                  :aria-describedby="ariaDescribedby"
                  name="Budget Avaibility"
                  v-validate="'required'"
                  value="Not Available"
                  >Not Available</b-form-radio
                >
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Budget Avaibility')"
                  >{{ errors.first("Budget Avaibility") }}</span
                >
              </b-form-group>
            </div>
          </div>
          <div class="my-3">
            <label class="mb-0"
              >Expected Business Process
              <span class="text-danger">*</span></label
            >
            <textarea
              name="Expected Business Process"
              class="form-control"
              v-model="payloadIdeation.expected_business_process"
              v-validate="'required'"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Expected Business Process')"
              >{{ errors.first("Expected Business Process") }}</span
            >
          </div>
          <!-- <div class="form-group mt-3">
                        <label>Objective <span class="text-danger">*</span></label>
                        <textarea class="form-control" v-model="payloadIdeation.background[4].objective" name="Objective"
                        v-validate="'required'"></textarea>
                            <span class="text-sm text-danger"
                                v-show="errors.has('Objective')">{{errors.first("Objective")}}</span>
                        </div> -->
          <button
            style="margin-left: 10px; float: right"
            class="mt-4 btn btn-primary"
            @click="tabIndex++"
          >
            Next
          </button>
        </b-tab>
        <b-tab title="Benefit">
          <h4 class="mt-3">
            1. Commercial Benefit if this Ideation will be implemented
            <span class="text-danger">*</span>
          </h4>
          <div
            v-for="(item, index) in payloadIdeation.benefit[0].items"
            :key="index"
          >
            <b-form-checkbox
              :id="`checkbox-${item.label}`"
              :name="`checkbox-${item.label}`"
              :value="true"
              :unchecked-value="false"
              v-model="item.selected"
              v-validate="'required'"
            >
              {{ item.label }}
            </b-form-checkbox>

            <div class="mb-3" v-if="item.selected == true">
              <label class="mb-0"
                >Write down the reasons
                <span class="text-danger">*</span></label
              >
              <textarea
                class="form-control"
                v-model="item.reason"
                :name="`Reason ${item.label}`"
                v-validate="'required'"
              />
              <span
                class="text-sm text-danger"
                v-show="errors.has(`Reason ${item.label}`)"
                >{{ errors.first(`Reason ${item.label}`) }}</span
              >
            </div>
          </div>
          <span v-if="validationBenefit" class="text-sm text-danger">
            Please select at least one Commercial Benefit
          </span>
          <h4 class="mt-5">
            2. Expected Payback Periode of this Project
            <span class="text-danger">*</span>
          </h4>
          <b-form-group v-slot="{ ariaDescribedby }">
            <b-form-radio
              v-model="payloadIdeation.benefit[1].value"
              :aria-describedby="ariaDescribedby"
              name="Payback Period"
              v-validate="'required'"
              value="Less than 1 year"
              >Less than 1 year</b-form-radio
            >
            <b-form-radio
              v-model="payloadIdeation.benefit[1].value"
              :aria-describedby="ariaDescribedby"
              name="Payback Period"
              v-validate="'required'"
              value="More than 1 year"
              >More than 1 year</b-form-radio
            >
            <b-form-radio
              v-model="payloadIdeation.benefit[1].value"
              :aria-describedby="ariaDescribedby"
              name="Payback Period"
              v-validate="'required'"
              value="None"
              >None</b-form-radio
            >
            <span
              class="text-sm text-danger"
              v-show="errors.has('Payback Period')"
              >{{ errors.first("Payback Period") }}</span
            >
          </b-form-group>
          <div class="mb-3">
            <label class="mb-0"
              >Write down the reasons <span class="text-danger">*</span></label
            >
            <textarea
              class="form-control"
              v-model="payloadIdeation.benefit[1].reason"
              name="Reason"
              v-validate="'required'"
            ></textarea>
            <span class="text-sm text-danger" v-show="errors.has('Reason')">{{
              errors.first("Reason")
            }}</span>
          </div>
          <!-- save button when add state -->
          <div class="form-group" v-if="isAdd == true">
            <div v-if="isLoading == false">
              <button
                style="margin-left: 10px; float: right"
                class="mt-4 btn btn-primary"
                @click="saveSubmit('submit')"
              >
                Submit
              </button>
              <button
                style="margin-left: 10px; float: right"
                class="mt-4 btn btn-warning"
                @click="saveSubmit('draft')"
              >
                Save as Draft
              </button>
            </div>
            <div v-else>
              <button
                style="margin-left: auto; float: right"
                class="mt-4 btn btn-primary"
                type="button"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            </div>
          </div>
          <!-- Save button when update state -->
          <div class="form-group" v-else>
            <div v-if="isLoading == false">
              <button
                style="margin-left: 10px; float: right"
                class="mt-4 btn btn-primary"
                @click="editSubmit('submit')"
              >
                Submit
              </button>
              <button
                style="margin-left: 10px; float: right"
                class="mt-4 btn btn-warning"
                @click="editSubmit('draft')"
              >
                Save as Draft
              </button>
            </div>
            <div v-else>
              <button
                style="margin-left: auto; float: right"
                class="mt-4 btn btn-primary"
                type="button"
                disabled
              >
                <span
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Loading...
              </button>
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal
      id="modal-detail-development"
      hide-footer
      size="xl"
      title="Detail Development"
    >
      <b-tabs v-if="dataDetails">
        <b-tab title="DIFO Project Development">
          <div class="row mt-3">
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold"
                  >Project Development Request By</label
                >
                <p>{{ dataDetails.created_by?.fullname }}</p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold">Realese Initiate</label>
                <p>
                  {{
                    Array.isArray(dataDetails.feature)
                      ? "Partial Release"
                      : "Full Release"
                  }}
                </p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold">Module</label>
                <p>{{ dataDetails.name }}</p>
              </div>
            </div>
            <div class="col-lg-6">
              <div class="form-group">
                <label class="font-weight-bold">Feature</label>
                <ul class="ps-3 mb-0">
                  <li
                    v-for="(feature, index) in dataDetails.feature"
                    :key="index"
                  >
                    {{ feature }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="row align-items-center">
                  <div class="col ms-n2">
                    <!-- Title -->
                    <h4 class="mb-1 font-weight-bold">Notes</h4>

                    <!-- Text -->
                    <p class="text-body-secondary mb-1">
                      {{ dataDetails.notes }}
                    </p>
                  </div>
                </div>
                <!-- / .row -->
              </div>
              <!-- / .card-body -->
            </div>
          </div>
        </b-tab>
        <b-tab title="SPG Pra Go Live" v-if="dataDetails.pra_go_live_flow">
          <div class="form-group">
            <label class="font-weight-bold">Pra Go Live by</label>
            <p>{{ dataDetails.pra_go_live_spg?.fullname }}</p>
          </div>
          <div class="row mt-5">
            <div
              class="col-lg-3"
              v-for="(item, index) in dataDetails.pra_go_live_flow"
              :key="index"
            >
              <div class="card">
                <div class="card-body">
                  <div class="row align-items-center">
                    <div class="col ms-n2">
                      <!-- Title -->
                      <h4 class="mb-1 font-weight-bold">
                        {{ item.title }}
                      </h4>

                      <!-- Text -->
                      <p class="small text-body-secondary mb-1">
                        Link :
                        <b-link @click="functionLink(item.link)">
                          {{
                            item.link.length > 20
                              ? item.link.slice(0, 20) + "..."
                              : item.link
                          }}
                        </b-link>
                      </p>

                      <!-- Status -->
                      <p class="small mb-0">
                        Notes :
                        <span class="text-muted">{{
                          item.notes ? item.notes : "-"
                        }}</span>
                      </p>
                    </div>
                  </div>
                  <!-- / .row -->
                </div>
                <!-- / .card-body -->
              </div>
            </div>
          </div>
        </b-tab>
        <b-tab title="SPG Go Live" v-if="dataDetails.go_live_flow">
          <div class="form-group">
            <label class="font-weight-bold">Go Live by</label>
            <p>{{ dataDetails.go_live_spg.fullname }}</p>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col ms-n2">
                  <!-- Title -->
                  <h4 class="mb-1 font-weight-bold">Go Live Notes</h4>

                  <!-- Text -->
                  <p class="small text-body-secondary mb-1">
                    {{ dataDetails.go_live_flow }}
                  </p>
                </div>
              </div>
              <!-- / .row -->
            </div>
            <!-- / .card-body -->
          </div>
        </b-tab>
        <b-tab
          title="Demand Touchpoint Monitoring"
          v-if="dataDetails.monitoring_flow"
        >
          <div class="form-group">
            <label class="font-weight-bold">Monitoring by</label>
            <p>{{ dataDetails.monitoring_demand_touchpoint?.fullname }}</p>
          </div>

          <b-tabs>
            <b-tab title="Month 1">
              <div
                class="card mt-2"
                v-for="(item, index) in dataDetails.monitoring_flow.month_1"
                :key="index"
              >
                <div class="card-header">
                  <div class="card-header-tittle">Rate {{ index + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Adoption Rate</label>
                        <p v-html="checkLink(item.adoption_rate)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold"
                          >Benefit Realization</label
                        >
                        <p v-html="checkLink(item.benefit_realization)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Adoption</label>
                        <p>{{ item.notes_adoption }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Benefit</label>
                        <p>{{ item.notes_benefit }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Month 2">
              <div
                class="card mt-2"
                v-for="(item, index) in dataDetails.monitoring_flow.month_2"
                :key="index"
              >
                <div class="card-header">
                  <div class="card-header-tittle">Rate {{ index + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Adoption Rate</label>
                        <p v-html="checkLink(item.adoption_rate)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold"
                          >Benefit Realization</label
                        >
                        <p v-html="checkLink(item.benefit_realization)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Adoption</label>
                        <p>{{ item.notes_adoption }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Benefit</label>
                        <p>{{ item.notes_benefit }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <b-tab title="Month 3">
              <div
                class="card mt-2"
                v-for="(item, index) in dataDetails.monitoring_flow.month_3"
                :key="index"
              >
                <div class="card-header">
                  <div class="card-header-tittle">Rate {{ index + 1 }}</div>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold">Adoption Rate</label>
                        <p v-html="checkLink(item.adoption_rate)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group">
                        <label class="font-weight-bold"
                          >Benefit Realization</label
                        >
                        <p v-html="checkLink(item.benefit_realization)"></p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Adoption</label>
                        <p>{{ item.notes_adoption }}</p>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="form-group flex-grow-1">
                        <label class="font-weight-bold">Reason Benefit</label>
                        <p>{{ item.notes_benefit }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>
      </b-tabs>
    </b-modal>
    <b-modal
      id="modal-development"
      hide-footer
      size="xl"
      :title="
        typeAction === 'pra_golive'
          ? 'Pra Go Live Form'
          : typeAction === 'golive'
          ? 'Go Live Form'
          : typeAction === 'monitoring'
          ? 'Monitoring Form'
          : 'Default Title'
      "
      @hide="onHide"
    >
      <div v-if="typeAction == 'pra_golive'">
        <div class="d-flex justify-content-between align-items-center">
          <h3>Pra Go Live Gathering of SPG</h3>
          <b-button variant="primary" class="ml-auto" @click="addNewLink">
            <span class="fe fe-plus"></span> Add
          </b-button>
        </div>
        <div style="max-height: 600px !important; overflow-x: scroll">
          <div
            class="row mt-3"
            v-for="(item, index) in bodyVerifDP"
            :key="index"
          >
            <div class="col-lg-3">
              <div class="form-group">
                <label
                  >Title
                  <span class="text-danger" v-if="index <= 3">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="item.title"
                  :name="`Title-${index}`"
                  v-validate="index <= 3 ? 'required' : ''"
                  :disabled="index <= 3"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has(`Title-${index}`)"
                  >{{ errors.first(`Title-${index}`) }}</span
                >
              </div>
            </div>
            <div class="col-lg-3">
              <div class="form-group">
                <label
                  >Shortlink
                  <span class="text-danger" v-if="index <= 3">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  v-model="item.link"
                  :name="`Shortlink-${index}`"
                  v-validate="index <= 3 ? 'required' : ''"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has(`Shortlink-${index}`)"
                  >{{ errors.first(`Shortlink-${index}`) }}</span
                >
              </div>
            </div>
            <div class="col-lg-5">
              <div class="form-group">
                <label>Reason </label>
                <textarea
                  type="text"
                  class="form-control"
                  v-model="item.notes"
                />
              </div>
            </div>
            <div class="col-lg-1" v-if="index > 3">
              <b-button
                variant="primary"
                class="float-end mt-5"
                @click="clearFormVerifDP(index)"
                ><span class="fe fe-trash"></span
              ></b-button>
            </div>
          </div>
        </div>
        <div class="float-end">
          <div v-if="isLoading == false">
            <b-button variant="primary" @click="submitPraGolive()"
              >Submit</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
      <div v-if="typeAction == 'golive'">
        <div class="form-group mt-3">
          <label>Notes</label>
          <textarea class="form-control" v-model="bodyNotes.notes"></textarea>
        </div>
        <div class="float-end">
          <div v-if="isLoading == false">
            <b-button variant="primary" @click="submitGolive()"
              >Go Live</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
      <div v-if="typeAction == 'monitoring'">
        <div class="mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Month 1</h3>
            <b-button
              variant="primary"
              class="ml-auto"
              @click="addNewLinkMonitoring('month_1')"
            >
              <span class="fe fe-plus"></span> Add
            </b-button>
          </div>
          <div
            class="card mt-2"
            v-for="(item, index) in bodyVerifDP.month_1"
            :key="index"
          >
            <div class="card-header">
              <div class="card-header-tittle">Rate {{ index + 1 }}</div>
              <b-button
                variant="primary"
                v-if="index > 0"
                class="ms-2 d-flex align-items-center justify-content-center"
                style="height: 38px"
                @click="clearFormVerifDP(index, 'month_1')"
              >
                <span class="fe fe-trash"></span>
              </b-button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Adoption Rate <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.adoption_rate"
                      :name="`Adoption Rate-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Adoption Rate-${index}`)"
                      >{{ errors.first(`Adoption Rate-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Benefit Realization
                      <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.benefit_realization"
                      :name="`Benefit Realization-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Benefit Realization-${index}`)"
                      >{{ errors.first(`Benefit Realization-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Adoption</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_adoption"
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Benefit</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_benefit"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Month 2</h3>
            <b-button
              variant="primary"
              class="ml-auto"
              @click="addNewLinkMonitoring('month_2')"
            >
              <span class="fe fe-plus"></span> Add
            </b-button>
          </div>
          <div
            class="card mt-2"
            v-for="(item, index) in bodyVerifDP.month_2"
            :key="index"
          >
            <div class="card-header">
              <div class="card-header-tittle">Rate {{ index + 1 }}</div>
              <b-button
                variant="primary"
                v-if="index > 0"
                class="ms-2 d-flex align-items-center justify-content-center"
                style="height: 38px"
                @click="clearFormVerifDP(index, 'month_2')"
              >
                <span class="fe fe-trash"></span>
              </b-button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Adoption Rate <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.adoption_rate"
                      :name="`Adoption Rate-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Adoption Rate-${index}`)"
                      >{{ errors.first(`Adoption Rate-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Benefit Realization
                      <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.benefit_realization"
                      :name="`Benefit Realization-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Benefit Realization-${index}`)"
                      >{{ errors.first(`Benefit Realization-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Adoption</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_adoption"
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Benefit</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_benefit"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-3">
          <div class="d-flex justify-content-between align-items-center">
            <h3>Month 3</h3>
            <b-button
              variant="primary"
              class="ml-auto"
              @click="addNewLinkMonitoring('month_3')"
            >
              <span class="fe fe-plus"></span> Add
            </b-button>
          </div>
          <div
            class="card mt-2"
            v-for="(item, index) in bodyVerifDP.month_3"
            :key="index"
          >
            <div class="card-header">
              <div class="card-header-tittle">Rate {{ index + 1 }}</div>
              <b-button
                variant="primary"
                v-if="index > 0"
                class="ms-2 d-flex align-items-center justify-content-center"
                style="height: 38px"
                @click="clearFormVerifDP(index, 'month_3')"
              >
                <span class="fe fe-trash"></span>
              </b-button>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Adoption Rate <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.adoption_rate"
                      :name="`Adoption Rate-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Adoption Rate-${index}`)"
                      >{{ errors.first(`Adoption Rate-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group">
                    <label
                      >Benefit Realization
                      <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="item.benefit_realization"
                      :name="`Benefit Realization-${index}`"
                      v-validate="'required'"
                    />
                    <span
                      class="text-sm text-danger"
                      v-show="errors.has(`Benefit Realization-${index}`)"
                      >{{ errors.first(`Benefit Realization-${index}`) }}</span
                    >
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Adoption</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_adoption"
                    ></textarea>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="form-group flex-grow-1">
                    <label>Reason Benefit</label>
                    <textarea
                      type="text"
                      class="form-control"
                      v-model="item.notes_benefit"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="float-end mt-3">
          <div v-if="isLoading == false">
            <b-button variant="primary" @click="submitMonitoring()"
              >Submit</b-button
            >
          </div>
          <button
            v-else
            style="margin-left: auto; float: right"
            class="mt-4 btn btn-primary"
            type="button"
            disabled
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
        </div>
      </div>
    </b-modal>
    <ModalNotification
      @show-modal="showModalNotification"
      @hide-modal="hideModalNotification"
      ref="modalNotification"
      :type="notificationType"
      :notifType="notifType"
      :recipientsRequestor="notificationRecipientsRequestor"
      :recipientsGG="notificationRecipientsGG"
      :cc="notificationCc"
      :ideationId="ideationId"
      :ideationName="ideationName"
      :ideationDate="ideationDate"
      :userName="fullnames"
      :userRole="roles"
    />
  </div>
</template>

<script>
import axiosIns from "@/api/axios";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import { props } from "vue2-dropzone";
import ModalNotification from "@/components/ideation/ModalNotification.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Ideation",
  components: {
    Datepicker,
    ModalNotification,
  },
  computed: {
    ideationList() {
      return this.$store.getters["ideation/listIdeation"]
        ? this.$store.getters["ideation/listIdeation"]
        : [];
    },
    moduleList() {
      return this.$store.getters["ideation/listModule"]
        ? this.$store.getters["ideation/listModule"]
        : [];
    },
    requestorList() {
      return this.$store.getters["userData/requestorList"]
        ? this.$store.getters["userData/requestorList"]
        : [];
    },
    ggList() {
      return this.$store.getters["userData/ggList"]
        ? this.$store.getters["userData/ggList"]
        : [];
    },
  },
  data() {
    return {
      isLoading: false,
      isAdd: false,
      tabIndex: 1,
      typeAction: "",
      moduleId: "",
      ideationId: "",
      ideationName: "",
      ideationDate: "",
      notificationRecipientsRequestor: [],
      notificationRecipientsGG: [],
      notificationCc: [],
      isAcknowledge: false,
      roles: "",
      bodyVerifDP: {},
      bodyNotes: {
        notes: "",
      },
      idIdeation: "",
      fullnames: "",
      dataDetails: {},
      actives: "",
      body: {
        page: 1,
        pageSize: 10,
        search: "",
        field: "",
        order: "",
        status: "",
      },
      bodyModule: {
        page: 1,
        pageSize: 10,
        search: "",
        field: "",
        order: "",
        status: "",
      },
      validationBenefit: false,
      validationBackground: false,
      payloadIdeation: {
        name: "",
        requestor_nik: "",
        genta_gendis_email: "",
        type: "",
        date: "",
        time_delivery: "1 - 3 Month",
        expected_business_process: "",
        background: [
          {
            selected: false,
            reason: null,
            label: "Regulation",
          },
          {
            selected: false,
            reason: null,
            label: "Management Call",
          },
          {
            selected: false,
            reason: null,
            label: "Improvement",
          },
          {
            selected: false,
            reason: null,
            label: "Others",
          },
          {
            objective: null,
          },
        ],
        benefit: [
          {
            items: [
              {
                selected: false,
                reason: null,
                label: "Cost Saving",
              },
              {
                selected: false,
                reason: null,
                label: "Time Saving",
              },
              {
                selected: false,
                reason: null,
                label: "Potential Lost Avoidance",
              },
              {
                selected: false,
                reason: null,
                label: "Other Benefit",
              },
              {
                selected: false,
                reason: null,
                label: "None",
              },
            ],
          },
          {
            value: "",
            reason: "",
          },
        ],
        budget_availability: [
          {
            items: [
              {
                selected: false,
                label: "Available",
              },
              {
                selected: false,
                label: "Not Available",
              },
            ],
          },
          {
            value: "",
          },
        ],
      },
      columns: [
        {
          label: "NO",
          field: "no",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
        {
          label: "Project Ideation Name",
          field: "name",
        },
        {
          label: "Requestor Name",
          field: "requestor.fullname",
        },
        {
          label: "Genta/Gendis",
          field: "genta_gendis.fullname",
        },
        {
          label: "Ideation Date",
          field: "date",
        },
        {
          label: "Created By",
          field: "created_by.fullname",
        },
        {
          label: "Scope",
          field: "scope",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Action",
          field: "action",
          width: "120px",
          sortable: false,
        },
      ],
      columnsModule: [
        {
          label: "NO",
          field: "no",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: false,
        },
        {
          label: "Project Ideation Name",
          field: "ideation.ideation_name",
        },
        {
          label: "Module",
          field: "name",
        },
        {
          label: "Feature",
          field: "feature",
        },
        {
          label: "Ideation Date",
          field: "date",
        },
        {
          label: "Status",
          field: "status",
        },
        {
          label: "Action",
          thClass: "text-center",
          field: "action",
          width: "200px",
          sortable: false,
        },
      ],
    };
  },

  mounted() {
    let status = this.$store.getters["ideation/typeOf"];
    if (status == "all") {
      this.actives = "all";
      (this.body.status = "ALL_IDEATION"), this.getListIdeation();
    } else if (status == "draft") {
      this.actives = "draft";
      this.body.status = "DRAFT";
      this.getListIdeation();
    } else if (status == "on_review") {
      this.actives = "on_review";
      this.body.status = "ON_REVIEW";
      this.getListIdeation();
    } else if (status == "revision") {
      this.actives = "revision";
      this.body.status = "REVISION";
      this.getListIdeation();
    } else if (status == "rejected") {
      this.actives = "rejected";
      this.body.status = "REJECTED";
      this.getListIdeation();
    } else if (status == "hold") {
      this.actives = "hold";
      this.body.status = "HOLD";
      this.getListIdeation();
    } else if (status == "development") {
      this.actives = "development";
      this.body.status = "DEVELOPMENT";
      this.getListIdeation();
    } else if (status == "dso") {
      this.actives = "dso";
      this.body.status = "DSO";
      this.getListIdeation();
    } else {
      this.actives = "all";
      this.getListIdeation();
    }
    this.getListModule();
    this.getListRequestor();
    this.getListgg();
    this.fullnames = localStorage.getItem("fullname");
    this.roles = localStorage.getItem("role_map");

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get("openIdeationForm") === "true") {
      this.$bvModal.show("modal-new-ideation");
      const urlParams = new URLSearchParams(window.location.search);
      const id = urlParams.get("id");
      this.isAdd = false;
      axiosIns
        .get(`${axiosIns.defaults.baseURL}/ideation/${id}`)
        .then((resp) => {
          let dat = resp.data.data;
          this.idIdeation = id;
          this.payloadIdeation.name = dat.overview.name;
          this.payloadIdeation.date = dat.overview.date;
          this.payloadIdeation.time_delivery = dat.overview.time_delivery;
          this.payloadIdeation.expected_business_process =
            dat.overview.expected_business_process;
          this.payloadIdeation.background = dat.overview.background;
          this.payloadIdeation.benefit = dat.overview.benefit;
          this.payloadIdeation.requestor_nik = dat.overview.requestor.nik;
          this.payloadIdeation.genta_gendis_email = dat.genta_gendis_flow.email;
        });
    }
  },
  methods: {
    getListIdeation() {
      this.body.isAcknowledge = this.isAcknowledge ? "1" : "0";
      this.isLoading = true;

      this.$store
        .dispatch("ideation/GET_ALL_IDEATION", this.body)
        .then((resp) => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getListModule() {
      this.isLoading = true;
      this.$store
        .dispatch("ideation/GET_ALL_MODULE", this.bodyModule)
        .then((resp) => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    handleIsAcknowledge() {
      this.getListIdeation();
    },
    getListRequestor() {
      let body = {
        limit: 100000000,
        page: 1,
      };
      this.$store.dispatch("userData/GET_ALL_REQUESTOR", body);
    },
    getListgg() {
      let body = {
        pageSize: 100000000,
        page: 1,
      };
      this.$store.dispatch("userData/GET_ALL_GG", body);
    },
    showEditDelete(status, fullname) {
      const isDraft =
        status === "Draft By General User" &&
        (fullname.includes(this.fullnames) || this.roles === "Super Admin");

      const isRevision =
        status === "Request Revision to General User" &&
        (fullname.includes(this.fullnames) || this.roles === "Super Admin");

      return isDraft || isRevision;
    },
    forDemandTouchpoint(status) {
      return status.includes("Demand Touch Point");
    },
    showModalNotification(type, data) {
      this.notificationType = type;

      let notifType = "";
      if (type === "acknowledge") {
        notifType = "Acknowledge";
      } else if (type === "fu acknowledge") {
        notifType = "Follow Up";
      } else if (type === "response acknowledge") {
        notifType = "Response";
      }
      this.notifType = notifType;
      this.ideationId = Number(data.id);
      this.ideationName = data.name;
      this.ideationDate = data.date;

      this.getUserEmailByIdeation(data.id);
      this.getUserEmailByRole().then(() => {
        setTimeout(() => {
          this.$bvModal.show("modal-notification");
        }, 500);
      });
    },

    hideModalNotification() {
      this.$bvModal.hide("modal-notification");
    },

    async getUserEmailByRole() {
      this.notificationCc = [];
      const response = await this.$store.dispatch(
        "userData/GET_ALL_USERS_BYROLE",
        {
          role: "Demand Touchpoint",
        }
      );
      const emails = response?.map((item) => item.email) || [];
      this.notificationCc.push(...emails);
    },

    async getUserEmailByIdeation(ideationId) {
      this.notificationRecipientsRequestor = [];
      this.notificationRecipientsGG = [];
      const response = await this.$store.dispatch(
        "ideation/GET_IDEATION_BYID",
        {
          id: ideationId,
        }
      );
      const requestorEmail = response?.overview?.requestor?.email;
      if (requestorEmail)
        this.notificationRecipientsRequestor.push(requestorEmail);

      const ggEmail = response?.genta_gendis_flow?.email;
      if (ggEmail) this.notificationRecipientsGG.push(ggEmail);
    },

    onPageChange(payload) {
      // this.body.pageSize = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.getListIdeation();
    },
    onPageChangeModule(payload) {
      // this.body.pageSize = payload.currentPerPage;
      this.bodyModule.page = payload.currentPage;
      this.getListModule();
    },

    onSortChange(params) {
      let sort1 = params[0].field;
      let sort2 = params[0].type;
      this.body.field = sort1;
      if (sort2 == "none") {
        this.body.order = "";
      } else {
        this.body.order = sort2;
      }
      this.getListIdeation();
    },
    onSortChangeModule(params) {
      let sort1 = params[0].field;
      let sort2 = params[0].type;
      this.bodyModule.field = sort1;
      if (sort2 == "none") {
        this.bodyModule.order = "";
      } else {
        this.bodyModule.order = sort2;
      }
      this.getListIdeation();
    },
    checkNIK(selectedValue) {
      const selectedItem = this.ggList.data.find(
        (item) => item.nik === selectedValue
      );
      console.log(selectedItem);

      if (selectedItem && (!selectedItem.nik || selectedItem.nik === "")) {
        this.$swal(
          "Warning",
          `NIK Not Found for Genta/Gendis '${selectedItem.name}'`,
          "warning"
        );
        this.payloadIdeation.genta_gendis_email = null;
      }
    },

    filterStatus(status) {
      if (status == "all") {
        (this.body.status = "ALL_IDEATION"), this.getListIdeation();
      } else if (status == "draft") {
        this.body.status = "DRAFT";
        this.getListIdeation();
      } else if (status == "on_review") {
        this.body.status = "ON_REVIEW";
        this.getListIdeation();
      } else if (status == "revision") {
        this.body.status = "REVISION";
        this.getListIdeation();
      } else if (status == "revision_verification") {
        this.body.status = "REVISION_VERIFICATION";
        this.getListIdeation();
      } else if (status == "rejected") {
        this.body.status = "REJECTED";
        this.getListIdeation();
      } else if (status == "hold") {
        this.body.status = "HOLD";
        this.getListIdeation();
      } else if (status == "development") {
        this.body.status = "DEVELOPMENT";
        this.getListIdeation();
      } else if (status == "dso") {
        this.body.status = "DSO";
        this.getListIdeation();
      }
    },
    filterModule(status) {
      if (status == "all_module") {
        this.bodyModule.status = "ALL_MODULE";
        this.getListModule();
      } else if (status == "development_module") {
        this.bodyModule.status = "PROJECT_DEVELOPMENT";
        this.getListModule();
      } else if (status == "pragolive_module") {
        this.bodyModule.status = "PRA_GO_LIVE";
        this.getListModule();
      } else if (status == "golive_module") {
        this.bodyModule.status = "GO_LIVE";
        this.getListModule();
      } else if (status == "monitoring_module") {
        this.bodyModule.status = "MONITORING";
        this.getListModule();
      } else if (status == "dso_module") {
        this.bodyModule.status = "DSO";
        this.getListModule();
      }
    },

    convertDate(str) {
      return moment(str).format("ddd, DD MMM YYYY");
    },

    backgroundList(data) {
      return data.slice(0, 4);
    },
    confirmClose() {
      const url = new URL(window.location);
      url.search = ""; // removes everything after the "?" in the URL
      window.history.replaceState({}, "", url);
      this.$bvModal.hide("modal-new-ideation");
    },
    idetionsnews() {
      this.isAdd = true;
      this.payloadIdeation = {
        name: "",
        requestor_nik: "",
        genta_gendis_email: "",
        type: "",
        date: "",
        time_delivery: "1 - 3 Month",
        expected_business_process: "",
        background: [
          {
            selected: false,
            reason: null,
            label: "Regulation",
          },
          {
            selected: false,
            reason: null,
            label: "Management Call",
          },
          {
            selected: false,
            reason: null,
            label: "Improvement",
          },
          {
            selected: false,
            reason: null,
            label: "Others",
          },
          {
            objective: null,
          },
        ],
        benefit: [
          {
            items: [
              {
                selected: false,
                reason: null,
                label: "Cost Saving",
              },
              {
                selected: false,
                reason: null,
                label: "Time Saving",
              },
              {
                selected: false,
                reason: null,
                label: "Potential Lost Avoidance",
              },
              {
                selected: false,
                reason: null,
                label: "Other Benefit",
              },
              {
                selected: false,
                reason: null,
                label: "None",
              },
            ],
          },
          {
            value: "",
            reason: "",
          },
        ],
        budget_availability: [
          {
            items: [
              {
                selected: false,
                label: "Available",
              },
              {
                selected: false,
                label: "Not Available",
              },
            ],
          },
          {
            value: "",
          },
        ],
      };
      if (this.roles == "General User") {
        let nik = localStorage.getItem("nik");
        this.payloadIdeation.requestor_nik = nik;
      }
      if (this.roles == "Genta Gendis") {
        let nik = localStorage.getItem("nik");
        let name = localStorage.getItem("fullname");
        if (nik == null) {
          this.$swal(
            "Warning",
            `NIK Not Found for Genta/Gendis ${name}`,
            "warning"
          );
        }
        this.payloadIdeation.genta_gendis_email = nik;
      }
    },
    splitText(text, length) {
      if (!text) return [];

      // If text exceeds 50 characters, truncate and add "..."
      if (text.length > 30) {
        text = text.substring(0, 30) + "...";
      }

      // Split into lines every 30 characters
      return text.match(/.{1,30}/g);
    },
    updateDraft(data) {
      this.isAdd = false;
      axiosIns
        .get(`${axiosIns.defaults.baseURL}/ideation/${data.id}`)
        .then((resp) => {
          let dat = resp.data.data;
          this.idIdeation = data.id;
          this.payloadIdeation.name = dat.overview.name;
          this.payloadIdeation.date = dat.overview.date;
          this.payloadIdeation.time_delivery = dat.overview.time_delivery;
          this.payloadIdeation.expected_business_process =
            dat.overview.expected_business_process;
          this.payloadIdeation.background = dat.overview.background;
          this.payloadIdeation.benefit = dat.overview.benefit;
          this.payloadIdeation.requestor_nik = dat.overview.requestor.nik;
          this.payloadIdeation.genta_gendis_email = dat.genta_gendis_flow.email;
        });
    },
    saveSubmit(type) {
      if (type == "draft") {
        this.payloadIdeation.type = type;
        this.isLoading = true;
        this.$store
          .dispatch("ideation/SAVE_NEW_IDEATION", this.payloadIdeation)
          .then((resp) => {
            this.isLoading = false;
            (this.payloadIdeation = {
              name: "",
              requestor_nik: "",
              genta_gendis_email: "",
              type: "",
              date: "",
              time_delivery: "1 - 3 Month",
              expected_business_process: "",
              background: [
                {
                  selected: false,
                  reason: null,
                },
                {
                  selected: false,
                  reason: null,
                },
                {
                  selected: false,
                  reason: null,
                },
                {
                  selected: false,
                  reason: null,
                },
                {
                  objective: null,
                },
              ],
              benefit: [
                {
                  items: [
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                  ],
                },
                {
                  value: "",
                  reason: "",
                },
              ],
              budget_availability: [
                {
                  items: [
                    {
                      selected: false,
                      label: null,
                    },
                    {
                      selected: false,
                      label: null,
                    },
                  ],
                },
                {
                  value: "",
                },
              ],
            }),
              this.getListIdeation();
            this.$bvModal.hide("modal-new-ideation");
            this.$swal(
              "Saved",
              `Your input has been saved ${type == "draft" ? "as draft" : ""}`,
              "success"
            );
          })
          .catch((err) => {
            this.isLoading = false;
            this.$swal("Error", `${err.response.data.error}`, "error");
          });
      } else {
        this.$validator.validateAll().then(async (res) => {
          const isBenefitEmpty = !this.payloadIdeation.benefit[0].items.some(
            (item) => item.selected
          );
          this.validationBenefit = isBenefitEmpty ? true : false;

          const isBackgroundEmpty = !this.payloadIdeation.background.some(
            (item) => item.selected
          );
          this.validationBackground = isBackgroundEmpty ? true : false;

          if (!res || isBenefitEmpty || isBackgroundEmpty) return false;
          try {
            // Validate background reasons
            const invalidBackground = this.payloadIdeation.background.some(
              (item) =>
                item.selected === true &&
                (!item.reason || item.reason.trim() === "")
            );

            // Validate benefit reasons
            const invalidBenefit = this.payloadIdeation.benefit.some(
              (benefitGroup) =>
                benefitGroup.items?.some(
                  (item) =>
                    item.selected === true &&
                    (!item.reason || item.reason.trim() === "")
                )
            );

            if (invalidBackground || invalidBenefit) {
              // this.$swal("Error", "Please provide a reason for all selected items.", "error");
              return false;
            }
            this.payloadIdeation.type = type;
            this.isLoading = true;
            this.$store
              .dispatch("ideation/SAVE_NEW_IDEATION", this.payloadIdeation)
              .then((resp) => {
                this.isLoading = false;
                (this.payloadIdeation = {
                  name: "",
                  requestor_nik: "",
                  genta_gendis_email: "",
                  type: "",
                  date: "",
                  time_delivery: "1 - 3 Month",
                  expected_business_process: "",
                  background: [
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      objective: null,
                    },
                  ],
                  benefit: [
                    {
                      items: [
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                      ],
                    },
                    {
                      value: "",
                      reason: "",
                    },
                  ],
                  budget_availability: [
                    {
                      items: [
                        {
                          selected: false,
                          label: null,
                        },
                        {
                          selected: false,
                          label: null,
                        },
                      ],
                    },
                    {
                      value: "",
                    },
                  ],
                }),
                  this.getListIdeation();
                this.$bvModal.hide("modal-new-ideation");
                this.$swal(
                  "Saved",
                  `Your input has been saved ${
                    type == "draft" ? "as draft" : ""
                  }`,
                  "success"
                );
              })
              .catch((err) => {
                this.isLoading = false;
                this.$swal("Error", `${err.response.data.error}`, "error");
              });
          } catch (resp) {
            this.$swal("Error", this.$t("Error while add data"), "error");
          }
        });
      }
    },
    editSubmit(type) {
      if (type == "draft") {
        this.isLoading = true;
        this.payloadIdeation.type = type;
        let body = {
          id: this.idIdeation,
          payload: this.payloadIdeation,
        };
        this.$store
          .dispatch("ideation/SAVE_DRAFT_IDEATION", body)
          .then((resp) => {
            this.isLoading = false;
            (this.payloadIdeation = {
              name: "",
              requestor_nik: "",
              genta_gendis_email: "",
              type: "",
              date: "",
              time_delivery: "1 - 3 Month",
              expected_business_process: "",
              background: [
                {
                  selected: false,
                  reason: null,
                },
                {
                  selected: false,
                  reason: null,
                },
                {
                  selected: false,
                  reason: null,
                },
                {
                  selected: false,
                  reason: null,
                },
                {
                  objective: null,
                },
              ],
              benefit: [
                {
                  items: [
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                  ],
                },
                {
                  value: "",
                  reason: "",
                },
              ],
            }),
              this.getListIdeation();
            this.$bvModal.hide("modal-new-ideation");
            this.$swal("Saved", "Your input has been saved", "success");
            const url = new URL(window.location);
            url.search = ""; // removes everything after the "?" in the URL
            window.history.replaceState({}, "", url);
          })
          .catch((err) => {
            this.isLoading = false;
            this.$swal("Error", `${err.response.data.error}`, "error");
          });
      } else {
        this.$validator.validateAll().then(async (res) => {
          if (!res) return false;
          try {
            this.isLoading = true;
            this.payloadIdeation.type = type;
            let body = {
              id: this.idIdeation,
              payload: this.payloadIdeation,
            };
            this.$store
              .dispatch("ideation/SAVE_DRAFT_IDEATION", body)
              .then((resp) => {
                this.isLoading = false;
                (this.payloadIdeation = {
                  name: "",
                  requestor_nik: "",
                  genta_gendis_email: "",
                  type: "",
                  date: "",
                  time_delivery: "1 - 3 Month",
                  expected_business_process: "",
                  background: [
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      selected: false,
                      reason: null,
                    },
                    {
                      objective: null,
                    },
                  ],
                  benefit: [
                    {
                      items: [
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                        {
                          selected: false,
                          reason: null,
                        },
                      ],
                    },
                    {
                      value: "",
                      reason: "",
                    },
                  ],
                }),
                  this.getListIdeation();
                this.$bvModal.hide("modal-new-ideation");
                this.$swal("Saved", "Your input has been saved", "success");
                const url = new URL(window.location);
                url.search = ""; // removes everything after the "?" in the URL
                window.history.replaceState({}, "", url);
              })
              .catch((err) => {
                this.isLoading = false;
                this.$swal("Error", `${err.response.data.error}`, "error");
              });
          } catch (resp) {
            this.$swal("Error", this.$t("Error while add data"), "error");
          }
        });
      }
    },
    deleteData(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch("ideation/DELETE_IDEATION", id)
            .then((resp) => {
              this.getListIdeation();
              this.$swal("Deleted!", "Your input has been deleted", "success");
            })
            .catch((err) => {
              this.$swal("Error", `${err.response.data.error}`, "error");
            });
        }
      });
    },
    detailModule(id) {
      this.$store.dispatch("ideation/GET_MODULE_DETAIL", id).then((resp) => {
        this.dataDetails = this.$store.getters["ideation/detailModule"];
        console.log(this.dataDetails);

        setTimeout(() => {
          this.$bvModal.show("modal-detail-development");
        }, 1000);
      });
    },
    checkLink(text) {
      const urlPattern =
        /((https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/\S*)?)/g;
      return text.replace(urlPattern, (match) => {
        let url = match;
        if (!/^https?:\/\//i.test(match)) {
          url = "http://" + match;
        }
        return `<a href="${url}" target="_blank">${match}</a>`;
      });
    },
    addNewLink() {
      const bodys = {
        title: "",
        link: "",
        notes: "",
      };
      this.bodyVerifDP.push(bodys);
    },
    addNewLinkMonitoring(month) {
      const bodys = {
        adoption_rate: "",
        benefit_realization: "",
        notes_adoption: "",
        notes_benefit: "",
      };
      if (month == "month_1") {
        this.bodyVerifDP.month_1.push(bodys);
      } else if (month == "month_2") {
        this.bodyVerifDP.month_2.push(bodys);
      } else if (month == "month_3") {
        this.bodyVerifDP.month_3.push(bodys);
      }
    },
    clearFormVerifDP(index, type) {
      if (type == "month_1") {
        this.bodyVerifDP.month_1.splice(index, 1);
      } else if (type == "month_2") {
        this.bodyVerifDP.month_2.splice(index, 1);
      } else if (type == "month_3") {
        this.bodyVerifDP.month_3.splice(index, 1);
      } else {
        this.bodyVerifDP.splice(index, 1);
      }
    },
    // SPG Pra Golive
    isPragoliveRole(status) {
      if (this.roles == "SPG" || this.roles == "Super Admin") {
        if (status == "Review Pra Go Live By SPG") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    openModalPragolive(type, id, ideation_id) {
      this.bodyVerifDP = [
        {
          title: "Sosialisasi",
          link: "",
          notes: "",
        },
        {
          title: "Training",
          link: "",
          notes: "",
        },
        {
          title: "BAST",
          link: "",
          notes: "",
        },
        {
          title: "Change Management",
          link: "",
          notes: "",
        },
      ];
      this.$bvModal.show("modal-development");
      this.typeAction = type;
      this.moduleId = id;
      this.ideationId = ideation_id;
    },
    submitPraGolive() {
      this.$swal({
        title: `Confirm Pra Go Live?`,
        text: `Are you sure want to submit this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$validator.validateAll().then(async (res) => {
            if (!res) return false;
            try {
              this.isLoading = true;
              this.$store
                .dispatch("ideation/PRA_GOLIVE_SPG", {
                  id: this.ideationId,
                  module_id: this.moduleId,
                  pra_go_live: this.bodyVerifDP,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved",
                    "success"
                  ).then(() => {
                    this.getListModule();
                    this.$bvModal.hide("modal-development");
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            } catch (resp) {
              this.$swal("Error", this.$t("Error while add data"), "error");
            }
          });
        }
      });
    },

    // Golive
    isGoLiveRole(status) {
      if (this.roles == "SPG" || this.roles == "Super Admin") {
        if (status == "Review Go Live By SPG") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    openModalGoLive(type, id, ideation_id) {
      this.$bvModal.show("modal-development");
      this.typeAction = type;
      (this.moduleId = id), (this.ideationId = ideation_id);
    },
    submitGolive() {
      this.$swal({
        title: `Confirm Go Live?`,
        text: `Are you sure want to submit this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$validator.validateAll().then(async (res) => {
            if (!res) return false;
            try {
              this.isLoading = true;
              this.$store
                .dispatch("ideation/GOLIVE_SPG", {
                  id: this.ideationId,
                  module_id: this.moduleId,
                  notes: this.bodyNotes,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved",
                    "success"
                  ).then(() => {
                    this.bodyNotes.notes = "";
                    this.getListModule();
                    this.$bvModal.hide("modal-development");
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            } catch (resp) {
              this.$swal("Error", this.$t("Error while add data"), "error");
            }
          });
        }
      });
    },

    // Monitoring
    isMonitoringFlow(status) {
      if (this.roles == "Demand Touchpoint" || this.roles == "Super Admin") {
        if (status == "Review Monitoring By Demand Touch Point") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    openModalMonitoring(type, id, ideation_id) {
      this.bodyVerifDP = {
        month_1: [
          {
            adoption_rate: "",
            benefit_realization: "",
            notes: "",
          },
        ],
        month_2: [
          {
            adoption_rate: "",
            benefit_realization: "",
            notes: "",
          },
        ],
        month_3: [
          {
            adoption_rate: "",
            benefit_realization: "",
            notes: "",
          },
        ],
      };
      this.$bvModal.show("modal-development");
      this.typeAction = type;
      this.moduleId = id;
      this.ideationId = ideation_id;
    },
    submitMonitoring() {
      this.$swal({
        title: `Confirm Monitoring?`,
        text: `Are you sure want to submit this input?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#00D97E",
        cancelButtonColor: "#E63757",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$validator.validateAll().then(async (res) => {
            if (!res) return false;
            try {
              this.isLoading = true;
              this.$store
                .dispatch("ideation/MONITORING", {
                  id: this.ideationId,
                  module_id: this.moduleId,
                  body: this.bodyVerifDP,
                })
                .then(() => {
                  this.isLoading = false;
                  this.$swal(
                    "Saved",
                    "Your input has been saved",
                    "success"
                  ).then(() => {
                    this.getListModule();
                    this.$bvModal.hide("modal-development");
                  });
                })
                .catch((err) => {
                  this.isLoading = false;
                  this.$swal("Error", `${err.response.data.error}`, "error");
                });
            } catch (resp) {
              this.$swal("Error", this.$t("Error while add data"), "error");
            }
          });
        }
      });
    },
  },
};
</script>
